import React from 'react';

// 辅助函数

/**
 * 格式化日期
 */
export function formatDate(
  date: string | Date,
  _format = 'yyyy-MM-dd HH:mm:ss',
): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

/**
 * 防抖函数
 */
export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function (this: any, ...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

/**
 * 节流函数
 */
export function throttle<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
): (...args: Parameters<T>) => void {
  let lastTime = 0;
  return function (this: any, ...args: Parameters<T>) {
    const now = Date.now();
    if (now - lastTime >= wait) {
      lastTime = now;
      func.apply(this, args);
    }
  };
}

/**
 * 高亮文本中的关键词
 */
export function highlightKeyword(
  text: string,
  keyword: string,
): React.ReactNode {
  if (!keyword || !text) {
    return text;
  }

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedKeyword})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) => {
    // 检查当前部分是否匹配关键词（不区分大小写）
    const isMatch =
      escapedKeyword && new RegExp(escapedKeyword, 'i').test(part);
    return isMatch
      ? React.createElement(
          'mark',
          {
            key: index,
            className:
              'bg-accent-subtle text-accent font-medium px-0.5 rounded',
          },
          part,
        )
      : part;
  });
}
